import React from 'react';
import SearchExpertForm from '../SearchExpertForm';

const Search = () => (
  <div>
    <SearchExpertForm />
  </div>
);

export default Search;
